import * as THREE from 'three';
import * as TWEEN from '@tweenjs/tween.js';
import { Pod } from '../entities/Pod.js';
import { MovementManager } from './MovementManager.js';

export class PodManager {
    constructor(sceneManager) {
        this.sceneManager = sceneManager;
        this.scene = sceneManager.getScene();
        this.camera = sceneManager.getCamera();
        
        // Track current pod state
        this.currentPodState = 'default'; // default, toolsets
        
        // Create pod and initialize movement
        this.initializePod();
    }

    initializePod() {
        this.pod = new Pod();
        this.scene.add(this.pod);
        
        // Initialize movement manager
        this.movementManager = new MovementManager(this.camera, this.pod);
    }

    startOrbitalMovement(onProgress) {
        this.movementManager.startMovement('briolissens', onProgress);
    }

    startForwardMovement(onProgress) {
        this.movementManager.startMovement('dunyawi', onProgress);
    }

    resetMovement() {
        this.movementManager.stopMovement();
        
        // Reset pod position
        new TWEEN.Tween(this.pod.position)
            .to({ x: 0, y: 0, z: 5 }, 1000)
            .easing(TWEEN.Easing.Quadratic.InOut)
            .start();
            
        // Reset camera position
        new TWEEN.Tween(this.camera.position)
            .to({ x: 0, y: 0, z: 5 }, 1000)
            .easing(TWEEN.Easing.Quadratic.InOut)
            .start();
    }

    update(time) {
        this.movementManager?.update(time);
        this.pod?.update(time);
    }
    
    getCurrentMovement() {
        return this.movementManager?.getCurrentMovementType() || null;
    }
    
    enableMorseCode() {
        if (this.pod) {
            this.pod.enableMorseCode();
        }
    }
    
    disableMorseCode() {
        if (this.pod) {
            this.pod.disableMorseCode();
        }
    }
    
    /**
     * Transform the pod for the toolsets view
     * - Stops blinking
     * - Adds a zigzag vertical line
     * - Displays "OB" on left and "AI" on right
     * - Changes eye colors (emerald green and pulsating gold)
     */
    transformPodForToolsets() {
        if (!this.pod) return;
        
        console.log('Transforming pod for toolsets view');
        this.currentPodState = 'toolsets';
        
        // Stop blinking
        this.pod.stopBlinking();
        
        // Change eye colors
        // Left eye: deep emerald green (#004D40) - darker than before
        // Right eye: pulsating gold (#FFD700)
        // Keep the outer circle dark like in stories section
        this.pod.setEyeColors(0x004D40, 0xC8A951, true);
        
        // Enable pulsating effect for right eye
        this.pod.enableRightEyePulsating();
        
        // Add vertical zigzag line and text
        this.pod.addVerticalDivider();
        this.pod.addHemisphereLabels();
    }
    
    /**
     * Reset the pod to its default appearance
     */
    resetPodAppearance() {
        if (!this.pod) return;
        
        console.log('Resetting pod appearance');
        this.currentPodState = 'default';
        
        // Reset eye colors
        this.pod.resetEyeColors();
        
        // Disable pulsating effect
        this.pod.disableRightEyePulsating();
        
        // Remove vertical line and text
        this.pod.removeVerticalDivider();
        this.pod.removeHemisphereLabels();
        
        // Restart normal blinking
        this.pod.startBlinking();
    }
}
